export function getDisplayName(args) {
  return {
    type: 'read',
    path: args.path,
    startLine: args.start_line,
    endLine: args.end_line
  };
}
